import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { BhPipesModule } from '@bh/pipes/pipes.module';

import { BhMaterialColorPickerComponent } from '@bh/components/material-color-picker/material-color-picker.component';

@NgModule({
    declarations: [
        BhMaterialColorPickerComponent
    ],
    imports: [
        CommonModule,

        FlexLayoutModule,

        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,

        BhPipesModule
    ],
    exports: [
        BhMaterialColorPickerComponent
    ],
})
export class BhMaterialColorPickerModule
{
}
